<template>
  <div style="background: #fff">
    <div id="flow-chart" :style="{ width: '100%', height: '30vh' }"></div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import { TooltipComponent, GridComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([TooltipComponent, GridComponent, BarChart, CanvasRenderer]);

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    list() {
      this.setChart();
    },
  },

  mounted() {
    var chartDom = document.getElementById("flow-chart");
    var myChart = echarts.init(chartDom);
    this.chart = myChart;
    this.setChart();
  },

  methods: {
    setChart() {
      if (this.list.length === 0) {
        return;
      }
      var option;

      const color = [
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#258E36",
            },
            {
              offset: 1,
              color: "#fff",
            },
          ],
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#6F83EF", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#fff", // 100% 处的颜色
            },
          ],
        },
      ];
      option = {
        color,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },

        grid: {
          top: "20%",
          right: "5%",
          bottom: "10%",
          left: "10%",
        },

        xAxis: [
          {
            type: "category",
            position: "top",
            boundaryGap: false,
            // data: this.list.map((item) => item.ts),
            data: this.list.map((item) =>
              item.ts.split(" ")[1].substring(0, 5)
            ),
          },
        ],
        yAxis: [
          {
            type: "value",
            inverse: true,
            axisLine: {
              show: true,
            },
          },
        ],
        series: [
          {
            name: "降雨量",
            type: "bar",
            data: this.list.map((item) => item.count),
          },
        ],
      };

      option && this.chart.setOption(option);
    },
  },
};
</script>